class SocialShop extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      copyToClipboard: '[data-copy-to-clipboard]',
      countrySelector: '[data-social-shop-country-selector]'
    }

    this.classes = {
      copiedSuccess: 'copied--success'
    }

    this.data = {
      clipboardText: 'clipboardText',
      website: 'website'
    }

    this.copyToClipboard = this.querySelector(this.selectors.copyToClipboard);
    this.countrySelector = this.querySelector(this.selectors.countrySelector);
    
    this.initEvents();
  }

  initEvents() {
    this.copyToClipboard.addEventListener('click', this.copy);
    this.countrySelector.addEventListener('change', this.onCountryChange);
  }

  copy = (e) => {
    console.log('clicked')
    const button = e.currentTarget;
    const textToCopy = button.dataset[this.data.clipboardText];

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
          button.classList.add(this.classes.copiedSuccess);
          setTimeout(() => button.classList.remove(this.classes.copiedSuccess), 1000);
      })
      .catch(err => console.error("Copy failed:", err));
  }

  onCountryChange = (e) => {
    const option = e.detail.option;

    const website = option.dataset[this.data.website];
    window.location.href = website;
  }
  
}

customElements.define('social-shop', SocialShop);